import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import QmAlert from '../qmAlert';
import {Tooltip} from 'antd';
import type {Rig} from "__generated__/graphql/types";

export interface OffshoreLocListProps {
    rigData: Rig[]
    style?: React.CSSProperties
    onOffshoreLocClick?: (id: string, name: string, classType: string) => void,
    selectedID?: string
}


const OffshoreLocList: React.FC<OffshoreLocListProps> = (props) => {
    return (
        <div className="dashboard" style={props.style}>
            <dl className="list-group bordered">
                <dt className="list-header"><span className="title">Offshore Location</span>
                    <div className="destinfowrap">
                        <span className="mc-qm-loc-list-header mc-qm-loc-list-header-onboard">
                            <Tooltip title="Onboard Passengers">
                                <FontAwesomeIcon icon={["fas", "users"]} />
                            </Tooltip>
                        </span>
                        <span className="mc-qm-loc-list-header mc-qm-loc-list-header-bed">
                            <Tooltip title="Available Beds">
                                <FontAwesomeIcon icon={["fas", "bed"]} />
                            </Tooltip>
                        </span>
                        <span className="mc-qm-loc-list-header mc-qm-loc-list-header-expected">
                            <Tooltip title="Expected Passengers">
                                <FontAwesomeIcon icon={["fas", "level-down-alt"]} />
                            </Tooltip>
                        </span>
                        <span className="mc-qm-loc-list-header mc-qm-loc-list-header-departing">
                            <Tooltip title="Departing Passengers">
                                <FontAwesomeIcon icon={["fas", "level-up-alt"]} />
                            </Tooltip>
                        </span>
                    </div>
                </dt>

                {/* ------------------  LOOP OVER LOCATION QUERY -------------------- */}
                {props.rigData.map(rigDoc => {

                    if (!rigDoc){
                        return null;
                    }

                    let bedQuartersCount = rigDoc.bedQuartersIds?.length || 0;

                    let onboardCount = rigDoc.onboardPobIdList?.length || 0;
                    let expectedCount = rigDoc.expectedPobIdList?.length || 0;
                    let departingCount = rigDoc.departingPobIdList?.length || 0;

                    let bedCountAlert;
                    let expectedAlert;
                    let departingAlert;
                    let onboardAlert;

                    let bedCountTooltip = "";

                    /* ---------------------------- */
                    if (expectedCount === 0) {
                        expectedAlert = 'none'
                    }
                    /* ---------------------------- */
                    if (departingCount === 0) {
                        departingAlert = 'none'
                    }
                    /* ---------------------------- */
                    if (onboardCount === 0) {
                        onboardAlert = 'none'
                    }
                    /* ---------------------------- */
                    if (bedQuartersCount === 0) {
                        bedCountAlert = 'critical'
                        bedCountTooltip = "No Beds Available"
                    } else if (bedQuartersCount < 5) {
                        bedCountAlert = 'warning'
                        bedCountTooltip = "Few Beds Available"
                    }

                    /* ------------------------------------------------------ */
                    /* item list (ACTIVE) for highlighting) */
                    return <dd key={rigDoc._id} className={`list-item ${props.selectedID === rigDoc._id ? "active" : ""}`} onClick={() => props.onOffshoreLocClick?.(rigDoc._id, rigDoc.name, rigDoc.classType)}>
                        <FontAwesomeIcon icon={["fas", "map-marker-alt"]} className="mc-qm-icon" />
                        <span className="title">{rigDoc.name}</span>
                        <div className="destinfowrap">
                            <QmAlert type={onboardAlert}>{onboardCount}</QmAlert>

                            <Tooltip title={bedCountTooltip}>
                                <QmAlert type={bedCountAlert}>{bedQuartersCount}</QmAlert>
                            </Tooltip>

                            <QmAlert type={expectedAlert}>{expectedCount}</QmAlert>
                            <QmAlert type={departingAlert}>{departingCount}</QmAlert>
                        </div>
                    </dd>
                })}
            </dl>
        </div>
    )
}


export default OffshoreLocList


